<template>
  <div class="carousel-container">
    <div class="carousel-scroll">
      <div
        v-for="(type, index) in types"
        :key="index"
        class="carousel-item"
        @click="selectType(index)"
      >
        <div
          class="carousel-item-text"
          :class="{ 'carousel-item_selected': selection === index }"
        >
          <div class="content">
            {{ type }}
            <div v-show="selection === index" class="item-border"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    types: {
      type: Array,
      default: () => new Array(5).fill('test'),
    },
    selection: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {}
  },
  methods: {
    selectType: function(index) {
      // this.selection = index
      this.$emit('selectTab', index)
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel-container {
  height: 48px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 1px 0 0 #ededed;
}

.carousel-scroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: none;
}

.carousel-scroll::-webkit-scrollbar {
  display: none;
}

.carousel-item {
  padding: 0px 20px;
  font-size: 15px;
  white-space: nowrap;
  display: flex;
  justify-content: center;

  .carousel-item-text {
    text-align: center;
    padding: 13px 0px;
    color: #4a4a4a;
    flex: 0 0 auto;
    display: inline-block;
    position: relative;

    .item-border {
      position: absolute;
      bottom: 0;
      width: 100%;
      border-bottom: 4px solid #1da7fc;
    }
  }
}

.carousel-item_selected {
  font-weight: bold;
  color: #222222 !important;
}
</style>
